import { Component, OnInit, OnDestroy, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';

@Component({
  selector: '[signup-account-type]',
  template: require('./signup-account-type.component.pug'),
  styles: [require('./signup-account-type.component.css').toString()],
})
export class SignupAccountTypeComponent implements OnInit, OnDestroy {
  csrf = '';

  googleUrl: string;
  microsoftUrl: string;
  linkedinUrl: string;
  facebookUrl: string;

  accountType: string = null;

  // -------------------------------------------------------------------
  constructor(@Inject(DOCUMENT) private document: any) {}

  // -------------------------------------------------------------------
  ngOnInit() {
    this.csrf = this.document.querySelector("meta[name='csrf-token']").content;
  }

  // -------------------------------------------------------------------
  ngOnDestroy() {}

  // -------------------------------------------------------------------
  setAcountType(type) {
    this.accountType = type;
    this.googleUrl = '/auth/google_oauth2?neworg=' + this.accountType;
    this.microsoftUrl = '/auth/microsoft_office365?neworg=' + this.accountType;
    this.linkedinUrl = '/auth/linkedin?neworg=' + this.accountType;
    this.facebookUrl = '/auth/facebook?neworg=' + this.accountType;
  }
}
